import { AbsenceLimitCalcTypeEnum } from "src/app/models/enums/absence-limit-calc-type-enum";
import { Moment } from 'moment';

export function equivalentHourlyAbsenceLimitCalcFunc(days: number): number {
  if (days <= 0) return 0;

  let points = 0;

  for (let day = 1; day <= days; day++) {
    if (day % 5 === 0) {
      points += 3;
    } else {
      points += 1;
    }
  }

  return points;
}

export function baseAbsenceLimitCalcFunc(areWeekendsDaysOff: boolean, daysOff: Date[], diff: number, endDate: Moment, startDate: Moment, absenceLimitCalcType: AbsenceLimitCalcTypeEnum) {
  if (!areWeekendsDaysOff && !daysOff) {
    diff = endDate.diff(startDate, 'days');
  } else {
    diff = 0;
    var date = startDate.toDate();

    while (date <= endDate.toDate()) {
      if (date.isWorkingDay(areWeekendsDaysOff, daysOff, absenceLimitCalcType)) {
        diff++;
      }

      date = date.addDays(1);
    }
  }
  return diff;
}